import React, { Component } from "react";
import { db } from "../../firebase/index";

import PostList from "./PostList";
import Header from '../structure/Header/Header';
import './PostsContainer.css';

let POSTLIST = [];

class PostsContainer extends Component {
  state = {
    boothId: this.props.props.match.params.boothId,
    postList: POSTLIST,
    getDb: false
  }

  componentDidMount() {
    POSTLIST = [];
    if (POSTLIST.length === 0){
      const { boothId } = this.state;
      db.collection("Post").orderBy("booth", "asc").orderBy("like", "desc").get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const { booth, register, like, url } = doc.data();
          // TODO: like 순으로 정렬하기 위해 모든 데이터를 다 불러옴. filter -> orederby 더 빠른 방법 필요.
          if (boothId === booth) {
            POSTLIST.push({
              postId: doc.id,
              register: register,
              like: like, 
              url: url
            });
          }
        })
      }).then(() => {
        this.setState({
          getDb: true, 
          postList: POSTLIST});
      });
    }
    else {
      this.setState({
        getDb: true
      })
    }
  }

  render(){
    const { boothId, getDb, postList } = this.state;
    return(
      <div className="posts-container">
        <Header />
        { getDb && (<PostList boothId={boothId} postList={postList}/>) }
        
      </div>
    );
  }
}
export default PostsContainer;